export const initialState = {
  adminLinkLists: [],
  viewUnviewUsers: [],
  viewEngagementLists: [],
  viewEngagementLinkId: null,
};
